/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { breakpoint } from "../../../../utils/breakpoint";
import { SvgHandler } from "../../svg-handler/svg-handler";

import facebookIcon from "../../../../assets/icons/social/facebook.svg";
import twitterIcon from "../../../../assets/icons/twitter.svg";
import linkedinIcon from "../../../../assets/icons/linkedin.svg";
import whatsappIcon from "../../../../assets/icons/social/whatsapp-share.svg";

import shareIcon from "../../../../assets/icons/social/shareicon.svg";
import closeIcon from "../../../../assets/icons/social/close.svg";

function getSocialShareData({ fbUrl, twitterUrl, gplusUrl, linkedinUrl, whatsappUrl, height = "24", width = "24" }) {
  return [
    {
      url: fbUrl,
      icon: <SvgHandler width={width} height={height} clazzName="facebook" xlinkHref={facebookIcon} />,
      alt: "fb icon",
      testAttr: "data-fb"
    },
    {
      url: twitterUrl,
      icon: <SvgHandler width={width} height={height} clazzName="twitter" xlinkHref={twitterIcon} />,
      alt: "twitter icon",
      testAttr: "data-tw"
    },
    {
      url: linkedinUrl,
      icon: <SvgHandler width={width} height={height} clazzName="linkedin" xlinkHref={linkedinIcon} />,
      alt: "linkedin icon",
      testAttr: "data-ln"
    },
    {
      url: whatsappUrl,
      icon: <SvgHandler width={width} height={height} clazzName="whatsapp-share" xlinkHref={whatsappIcon} />,
      alt: "whatsapp share",
      testAttr: "data-wp"
    }
  ];
}

export function popupSocialShareData({
  fbUrl,
  twitterUrl,
  linkedinUrl,
  whatsappUrl,
  height = "18",
  width = "18",
  color = "#fff"
}) {
  return [
    {
      url: fbUrl,
      icon: <SvgHandler width={width} height={height} clazzName="facebook" xlinkHref={facebookIcon} />,
      bgColor: "#4e71a8",
      text: "Facebook",
      alt: "fb icon"
    },
    {
      url: twitterUrl,
      icon: <SvgHandler width={width} height={height} clazzName="twitter" xlinkHref={twitterIcon} />,
      bgColor: "#1db7eb",
      text: "Twitter",
      alt: "twitter icon"
    },
    {
      url: linkedinUrl,
      icon: <SvgHandler width={width} height={height} clazzName="linkedin" xlinkHref={linkedinIcon} />,
      bgColor: "#0077B5",
      text: "LinkedIn",
      alt: "linkedin icon"
    },
    {
      url: whatsappUrl,
      icon: (
        <SvgHandler width="19" height="19" viewBox="0 0 24 24" clazzName="whatsapp-share" xlinkHref={whatsappIcon} />
      ),
      bgColor: "#25d366",
      text: "Whatsapp",
      alt: "whatsapp share"
    }
  ];
}

function getSocialShareElem(url, icon, alt, testAttrKey, index) {
  const testAttr = { [testAttrKey]: "true" };

  return (
    <li className="social-share-icon" {...testAttr} key={`social-item-${index}`}>
      <a href={url} target="_blank" rel="noopener noreferrer">
        {icon}
      </a>
    </li>
  );
}

export function getActionIcon(open, grey, greyShade, primaryColor) {
  return open ? (
    <SvgHandler width="24" height="24" clazzName="close" xlinkHref={closeIcon} />
  ) : (
    <SvgHandler width="24" height="24" clazzName="shareicon" xlinkHref={shareIcon} />
  );
}

export function getIconsList(params, vertical) {
  const iconsList = getSocialShareData(params);
  const tabletList = vertical
    ? null
    : iconsList
        .slice(0, 2)
        .map(({ url, icon, alt, testAttr }, index) => getSocialShareElem(url, icon, alt, testAttr, index));
  const desktopList = iconsList.map(({ url, icon, alt, testAttr }, index) =>
    getSocialShareElem(url, icon, alt, testAttr, index)
  );

  return breakpoint("tablet") ? tabletList : desktopList;
}
